import {
  Box,
  Button,
  Card,
  CardActions,
  CircularProgress,
} from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { Form, PasswordInput, useNotify, useTranslate } from "react-admin";
import { useNavigate, useSearchParams } from "react-router-dom";
import sendRequest from "../dataProvider/sendRequest";

interface FormValues {
  password: string;
  confirm_password: string;
}

const ResetPasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const translate = useTranslate();
  const notify = useNotify();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [checkPwdOneUppercase, setCheckPwdOneUppercase] = React.useState(false);
  const [checkPwdOneLowercase, setCheckPwdOneLowercase] = React.useState(false);
  const [checkPwdOneNumber, setCheckPwdOneNumber] = React.useState(false);
  const [checkPwd8Char, setCheckPwd8Char] = React.useState(false);
  const handleSubmit = async (auth: FormValues) => {
    if (auth.password !== auth.confirm_password) {
      notify("Passwords do not match", { type: "error" });
      return;
    }
    setLoading(true);
    const reqUrl = "reset-password";
    const formJson = {
      token: token,
      password: auth.password,
    };
    const response = await sendRequest(reqUrl, {
      id: 0,
      data: formJson,
    });
    if (response && (response.status == "200" || response.code == "200")) {
      notify("Password updated successfully!", { type: "success" });
      setTimeout(() => navigate("/login"), 1000);
    } else {
      notify("Invalid or expired token", { type: "error" });
    }
  };
  const validatePassword = (value: any) => {
    if (!value) return "Password is required";
    if (value.length < 8) return "Password must be at least 8 characters";
    if (!/[A-Z]/.test(value))
      return "Must include at least one uppercase letter";
    if (!/[a-z]/.test(value))
      return "Must include at least one lowercase letter";
    if (!/\d/.test(value)) return "Must include at least one number";

    return undefined;
  };
  const validateConfirmPassword = (value, { password }) => {
    // console.log("validateConfirmPassword", value, password);
    if (value !== password) return "The two passwords must match";
    return undefined;
  };
  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "flex-start",
          backgroundColor: "#f2f7fa",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Card sx={{ minWidth: 300, marginTop: "6em", padding: "2em" }}>
          <Box
            sx={{
              margin: "1em",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img src="/images/happymango_logo.png" alt="logo" border="0" />
          </Box>
          <Box
            sx={{
              marginTop: "1em",
              display: "flex",
              justifyContent: "center",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            RESET YOUR PASSWORD
          </Box>
          <Box
            sx={{
              marginTop: "1em",
              display: "flex",
              justifyContent: "center",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            This website is for institutional users only. Click here to log into
            your individual user account.
          </Box>
          <Box sx={{ mt: 2, padding: "0 1em 1em 1em" }}>
            <PasswordInput
              source="password"
              variant="outlined"
              label="New Password"
              validate={validatePassword}
              onChange={(e) => {
                const value = e.target.value;
                setCheckPwdOneUppercase(/[A-Z]/.test(value));
                setCheckPwdOneLowercase(/[a-z]/.test(value));
                setCheckPwdOneNumber(/\d/.test(value));
                setCheckPwd8Char(value.length >= 8);
              }}
              fullWidth
              required
            />

            <PasswordInput
              source="confirm_password"
              variant="outlined"
              label="Confirm Password"
              validate={validateConfirmPassword}
              fullWidth
              required
            />
          </Box>
          <CardActions
            sx={{
              padding: "0 1em 1em 1em",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              type="submit"
              color="primary"
              disabled={loading}
              fullWidth
            >
              {loading && <CircularProgress size={25} thickness={2} />}
              Reset Password
            </Button>
          </CardActions>
        </Card>
      </Box>
    </Form>
  );
};

export default ResetPasswordPage;
